// Grade data auto-generated by processPDFText.js
// Fri Jun 05 2020 22:00:05 GMT+0100 (British Summer Time)

export default
  {
    "trumpet": {
      "1": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "C", range: 8 },
          { type: "MIN", tonic: "A", range: 8 }
        ]
      },
      "2": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "Bb", range: 8 },
          { type: "MAJ", tonic: "D", range: 8 },
          { type: "MIN", tonic: "A", range: 8 },
          { type: "MIN", tonic: "D", range: 8 }
        ]
      },
      "3": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "Eb", range: 8 },
          { type: "MAJ", tonic: "E", range: 8 },
          { type: "MIN", tonic: "C", range: 8 },
          { type: "MIN", tonic: "E", range: 8 },
          { type: "MAJ", tonic: "A", range: 12 },
          { type: "CHR", tonic: "C", range: 8 }
        ]
      },
      "4": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "F", range: 8 },
          { type: "MIN", tonic: "F", range: 8 },
          { type: "MAJ", tonic: "Ab", range: 12 },
          { type: "MAJ", tonic: "Bb", range: 12 },
          { type: "MIN", tonic: "A", range: 12 },
          { type: "MIN", tonic: "B", range: 12 },
          { type: "CHR", tonic: "Bb", range: 12 }
        ]
      },
      "5": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "Bb", range: 12 },
          { type: "MAJ", tonic: "Db", range: 12 },
          { type: "MIN", tonic: "Bb", range: 12 },
          { type: "MIN", tonic: "C#", range: 12 },
          { type: "MAJ", tonic: "G", range: 15 },
          { type: "MAJ", tonic: "Ab", range: 15 },
          { type: "MIN", tonic: "G", range: 15 },
          { type: "CHR", tonic: "C", range: 12 },
          { type: "DOM7", tonic: "G", range: 15 }
        ]
      },
      "6": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "D", range: 12 },
          { type: "MIN", tonic: "C", range: 12 },
          { type: "MAJ", tonic: "F#", range: 15 },
          { type: "MAJ", tonic: "A", range: 15 },
          { type: "MIN", tonic: "G#", range: 15 },
          { type: "MIN", tonic: "A", range: 15 },
          { subinst: "trumpet", type: "MAJ", tonic: "Bb", range: 15 },
          { subinst: "trumpet", type: "MIN", tonic: "Bb", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "Bb", range: 12 },
          { type: "CHR", tonic: "F#", range: 15 },
          { type: "CHR", tonic: "G", range: 15 },
          { type: "CHR", tonic: "Ab", range: 15 },
          { type: "CHR", tonic: "A", range: 15 },
          { type: "DOM7", tonic: "A", range: 15 },
          { type: "DIM7", tonic: "G", range: 15 }
        ]
      },
      "7": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "trumpet", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "C", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "D", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "E", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "F", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trumpet", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "B", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "C", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "D", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "F#", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "G", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "Ab", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "A", range: 15 },
          { subinst: "eb-cornet", type: "MIN", tonic: "F#", range: 15 },
          { subinst: "eb-cornet", type: "MIN", tonic: "G", range: 15 },
          { subinst: "eb-cornet", type: "MIN", tonic: "G#", range: 15 },
          { subinst: "eb-cornet", type: "MIN", tonic: "A", range: 15 },
          { subinst: "trumpet", type: "CHR", tonic: "F#-B", range: 15 },
          { subinst: "eb-cornet", type: "CHR", tonic: "F#-A", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "eb-cornet", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "eb-cornet", type: "DOM7", tonic: "Ab", range: 15 },
          { type: "DIM7", tonic: "Ab", range: 15 },
          { type: "DIM7", tonic: "A", range: 15 }
        ]
      },
      "8": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "trumpet", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "D", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "E", range: 12 },
          { subinst: "trumpet", type: "MIN", tonic: "F", range: 12 },
          { subinst: "trumpet", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trumpet", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "B", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "C", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "D", range: 12 },
          { subinst: "eb-cornet", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "F#", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "G", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "Ab", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "A", range: 15 },
          { subinst: "eb-cornet", type: "MAJ", tonic: "Bb", range: 15 },
          { subinst: "eb-cornet", type: "MIN", tonic: "F#", range: 15 },
          { subinst: "eb-cornet", type: "MIN", tonic: "G", range: 15 },
          { subinst: "eb-cornet", type: "MIN", tonic: "G#", range: 15 },
          { subinst: "eb-cornet", type: "MIN", tonic: "A", range: 15 },
          { subinst: "eb-cornet", type: "MIN", tonic: "Bb", range: 15 },
          { subinst: "trumpet", type: "CHR", tonic: "F#-C", range: 15 },
          { subinst: "eb-cornet", type: "CHR", tonic: "F#-Bb", range: 15 },
          { subinst: "trumpet", type: "WT", tonic: "B", range: 15 },
          { subinst: "trumpet", type: "WT", tonic: "C", range: 15 },
          { subinst: "eb-cornet", type: "WT", tonic: "A", range: 15 },
          { subinst: "eb-cornet", type: "WT", tonic: "Bb", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "B", range: 15 },
          { subinst: "trumpet", type: "DOM7", tonic: "C", range: 15 },
          { subinst: "eb-cornet", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "eb-cornet", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "eb-cornet", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "eb-cornet", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "eb-cornet", type: "DOM7", tonic: "Bb", range: 15 },
          { type: "DIM7", tonic: "Ab", range: 15 },
          { type: "DIM7", tonic: "A", range: 15 },
          { type: "DIM7", tonic: "Bb", range: 15 }
        ]
      }
    },
    "trombone": {
      "1": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "trombone", type: "MAJ", tonic: "Bb", range: 8 },
          { subinst: "trombone", type: "MIN", tonic: "C", range: 8 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "C", range: 8 },
          { subinst: "trombone-treble", type: "MIN", tonic: "D", range: 8 }
        ]
      },
      "2": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "trombone", type: "MAJ", tonic: "Ab", range: 8 },
          { subinst: "trombone", type: "MAJ", tonic: "C", range: 8 },
          { subinst: "trombone", type: "MIN", tonic: "C", range: 8 },
          { subinst: "trombone", type: "MIN", tonic: "D", range: 8 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Bb", range: 8 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "D", range: 8 },
          { subinst: "trombone-treble", type: "MIN", tonic: "D", range: 8 },
          { subinst: "trombone-treble", type: "MIN", tonic: "E", range: 8 }
        ]
      },
      "3": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "trombone", type: "MAJ", tonic: "D", range: 8 },
          { subinst: "trombone", type: "MAJ", tonic: "Eb", range: 8 },
          { subinst: "trombone", type: "MIN", tonic: "D", range: 8 },
          { subinst: "trombone", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "G", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "E", range: 8 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "F", range: 8 },
          { subinst: "trombone-treble", type: "MIN", tonic: "E", range: 8 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "A", range: 12 },
          { subinst: "trombone", type: "CHR", tonic: "C", range: 8 },
          { subinst: "trombone-treble", type: "CHR", tonic: "D", range: 8 }
        ]
      },
      "4": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "trombone", type: "MAJ", tonic: "Db", range: 8 },
          { subinst: "trombone", type: "MIN", tonic: "E", startOctave: "LOWEST_PLUS_1", range: 8 },
          { subinst: "trombone", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "G", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Eb", range: 8 },
          { subinst: "trombone-treble", type: "MIN", tonic: "F#", startOctave: "LOWEST_PLUS_1", range: 8 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "A", range: 12 },
          { subinst: "trombone", type: "CHR", tonic: "Eb", range: 8 },
          { subinst: "trombone-treble", type: "CHR", tonic: "F", range: 8 }
        ]
      },
      "5": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "trombone", type: "MAJ", tonic: "A", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "C", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "F", range: 15 },
          { subinst: "trombone", type: "MAJ", tonic: "F#", range: 15 },
          { subinst: "trombone", type: "MAJ", tonic: "G", range: 15 },
          { subinst: "trombone", type: "MIN", tonic: "F", range: 15 },
          { subinst: "trombone", type: "MIN", tonic: "G", range: 15 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "D", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "G", range: 15 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Ab", range: 15 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "A", range: 15 },
          { subinst: "trombone-treble", type: "MIN", tonic: "G", range: 15 },
          { subinst: "trombone-treble", type: "MIN", tonic: "A", range: 15 },
          { subinst: "trombone", type: "CHR", tonic: "F", range: 15 },
          { subinst: "trombone-treble", type: "CHR", tonic: "G", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "F", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "G", range: 15 }
        ]
      },
      "6": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "trombone", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "E", range: 15 },
          { subinst: "trombone", type: "MAJ", tonic: "Ab", range: 15 },
          { subinst: "trombone", type: "MIN", tonic: "F#", range: 15 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "C", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "F#", range: 15 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Bb", range: 15 },
          { subinst: "trombone-treble", type: "MIN", tonic: "G#", range: 15 },
          { subinst: "trombone", type: "CHR", tonic: "G", range: 15 },
          { subinst: "trombone", type: "CHR", tonic: "Ab", range: 15 },
          { subinst: "trombone-treble", type: "CHR", tonic: "A", range: 15 },
          { subinst: "trombone-treble", type: "CHR", tonic: "Bb", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "trombone", type: "DIM7", tonic: "F", range: 15 },
          { subinst: "trombone-treble", type: "DIM7", tonic: "G", range: 15 }
        ]
      },
      "7": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "trombone", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "B", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "C", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "D", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trombone", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "D", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "E", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "F", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trombone-treble", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trombone", type: "CHR", tonic: "E-Bb", range: 15 },
          { subinst: "trombone-treble", type: "CHR", tonic: "F#-C", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "trombone", type: "DIM7", tonic: "G", range: 15 },
          { subinst: "trombone", type: "DIM7", tonic: "A", range: 15 },
          { subinst: "trombone-treble", type: "DIM7", tonic: "A", range: 15 },
          { subinst: "trombone-treble", type: "DIM7", tonic: "B", range: 15 }
        ]
      },
      "8": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "trombone", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "B", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "C", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "D", range: 12 },
          { subinst: "trombone", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "trombone", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trombone", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "D", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "E", range: 12 },
          { subinst: "trombone-treble", type: "MIN", tonic: "F", range: 12 },
          { subinst: "trombone-treble", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trombone-treble", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "trombone", type: "CHR", tonic: "E-Bb", range: 15 },
          { subinst: "trombone-treble", type: "CHR", tonic: "F#-C", range: 15 },
          { subinst: "trombone", type: "WT", tonic: "A", range: 15 },
          { subinst: "trombone", type: "WT", tonic: "Bb", range: 15 },
          { subinst: "trombone-treble", type: "WT", tonic: "B", range: 15 },
          { subinst: "trombone-treble", type: "WT", tonic: "C", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "E", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "F", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "trombone", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "B", range: 15 },
          { subinst: "trombone-treble", type: "DOM7", tonic: "C", range: 15 },
          { subinst: "trombone", type: "DIM7", tonic: "G", range: 15 },
          { subinst: "trombone", type: "DIM7", tonic: "Ab", range: 15 },
          { subinst: "trombone", type: "DIM7", tonic: "A", range: 15 },
          { subinst: "trombone-treble", type: "DIM7", tonic: "A", range: 15 },
          { subinst: "trombone-treble", type: "DIM7", tonic: "Bb", range: 15 },
          { subinst: "trombone-treble", type: "DIM7", tonic: "B", range: 15 }
        ]
      }
    },
    "bass-trombone": {
      "6": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "Ab", range: 12 },
          { type: "MAJ", tonic: "C", range: 15 },
          { type: "MAJ", tonic: "D", range: 15 },
          { type: "MAJ", tonic: "Eb", range: 15 },
          { type: "MIN", tonic: "C#", range: 15 },
          { type: "MIN", tonic: "D", range: 15 },
          { type: "MIN", tonic: "Eb", range: 15 },
          { type: "CHR", tonic: "C", range: 15 },
          { type: "CHR", tonic: "Db", range: 15 },
          { type: "DOM7", tonic: "E", range: 15 },
          { type: "DIM7", tonic: "C", range: 15 }
        ]
      },
      "7": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "C", range: 15 },
          { type: "MAJ", tonic: "Db", range: 15 },
          { type: "MAJ", tonic: "D", range: 15 },
          { type: "MAJ", tonic: "Eb", range: 15 },
          { type: "MAJ", tonic: "E", range: 15 },
          { type: "MAJ", tonic: "F", range: 15 },
          { type: "MIN", tonic: "C", range: 15 },
          { type: "MIN", tonic: "C#", range: 15 },
          { type: "MIN", tonic: "D", range: 15 },
          { type: "MIN", tonic: "Eb", range: 15 },
          { type: "MIN", tonic: "E", range: 15 },
          { type: "MIN", tonic: "F", range: 15 },
          { type: "MAJ", tonic: "ALL_KEYS", range: 12 },
          { type: "MIN", tonic: "ALL_KEYS", range: 12 },
          { type: "CHR", tonic: "C-Eb", range: 15 },
          { type: "DOM7", tonic: "C", range: 15 },
          { type: "DOM7", tonic: "D", range: 15 },
          { type: "DIM7", tonic: "C", range: 15 },
          { type: "DIM7", tonic: "Db", range: 15 }
        ]
      },
      "8": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "C", range: 15 },
          { type: "MAJ", tonic: "Db", range: 15 },
          { type: "MAJ", tonic: "D", range: 15 },
          { type: "MAJ", tonic: "Eb", range: 15 },
          { type: "MAJ", tonic: "E", range: 15 },
          { type: "MAJ", tonic: "F", range: 15 },
          { type: "MAJ", tonic: "F#", range: 15 },
          { type: "MAJ", tonic: "G", range: 15 },
          { type: "MIN", tonic: "C", range: 15 },
          { type: "MIN", tonic: "C#", range: 15 },
          { type: "MIN", tonic: "D", range: 15 },
          { type: "MIN", tonic: "Eb", range: 15 },
          { type: "MIN", tonic: "E", range: 15 },
          { type: "MIN", tonic: "F", range: 15 },
          { type: "MIN", tonic: "F#", range: 15 },
          { type: "MIN", tonic: "G", range: 15 },
          { type: "MAJ", tonic: "ALL_KEYS", range: 12 },
          { type: "MIN", tonic: "ALL_KEYS", range: 12 },
          { type: "CHR", tonic: "B-Eb", range: 15 },
          { type: "WT", tonic: "D", range: 15 },
          { type: "WT", tonic: "Eb", range: 15 },
          { type: "DOM7", tonic: "B", range: 15 },
          { type: "DOM7", tonic: "C", range: 15 },
          { type: "DOM7", tonic: "C#", range: 15 },
          { type: "DOM7", tonic: "D", range: 15 },
          { type: "DOM7", tonic: "Eb", range: 15 },
          { type: "DIM7", tonic: "C", range: 15 },
          { type: "DIM7", tonic: "Db", range: 15 },
          { type: "DIM7", tonic: "D", range: 15 }
        ]
      }
    },
    "horn": {
      "1": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "C", startOctave: "LOWEST_PLUS_1", range: 8 },
          { type: "MIN", tonic: "A", startOctave: "LOWEST_PLUS_1", range: 8 }
        ]
      },
      "2": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "Bb", startOctave: "LOWEST_PLUS_1", range: 8 },
          { type: "MAJ", tonic: "C", startOctave: "LOWEST_PLUS_1", range: 8 },
          { type: "MIN", tonic: "B", startOctave: "LOWEST_PLUS_1", range: 8 },
          { type: "MIN", tonic: "D", startOctave: "LOWEST_PLUS_1", range: 8 }
        ]
      },
      "3": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MIN", tonic: "C", startOctave: "LOWEST_PLUS_1", range: 8 },
          { type: "MIN", tonic: "E", startOctave: "LOWEST_PLUS_1", range: 8 },
          { type: "MAJ", tonic: "G", startOctave: "BELOW_STAFF", range: 12 },
          { type: "MAJ", tonic: "A", startOctave: "BELOW_STAFF", range: 12 },
          { type: "MIN", tonic: "G", startOctave: "BELOW_STAFF", range: 12 },
          { type: "CHR", tonic: "C", startOctave: "LOWEST_PLUS_1", range: 8 }
        ]
      },
      "4": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "Bb", startOctave: "LOWEST_PLUS_1", range: 12 },
          { type: "MIN", tonic: "A", startOctave: "LOWEST_PLUS_1", range: 12 },
          { type: "MIN", tonic: "B", startOctave: "LOWEST_PLUS_1", range: 12 },
          { type: "MAJ", tonic: "E", range: 15 },
          { type: "MAJ", tonic: "F", range: 15 },
          { type: "MIN", tonic: "F", range: 15 },
          { type: "CHR", tonic: "A", startOctave: "LOWEST_PLUS_1", range: 12 },
          { type: "DOM7", tonic: "G", range: 8 }
        ]
      },
      "5": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "Bb", startOctave: "LOWEST_PLUS_1", range: 12 },
          { type: "MAJ", tonic: "D", range: 15 },
          { type: "MAJ", tonic: "Eb", range: 15 },
          { type: "MAJ", tonic: "G", range: 15 },
          { type: "MIN", tonic: "D", range: 15 },
          { type: "MIN", tonic: "E", range: 15 },
          { type: "MIN", tonic: "F#", range: 15 },
          { type: "CHR", tonic: "F", range: 15 },
          { type: "DOM7", tonic: "G", range: 15 }
        ]
      },
      "6": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "C", range: 15 },
          { type: "MAJ", tonic: "Db", range: 15 },
          { type: "MAJ", tonic: "F#", range: 15 },
          { type: "MAJ", tonic: "Ab", range: 15 },
          { type: "MIN", tonic: "C#", range: 15 },
          { type: "MIN", tonic: "Eb", range: 15 },
          { type: "MIN", tonic: "G", range: 15 },
          { type: "MIN", tonic: "A", range: 15 },
          { type: "CHR", tonic: "E", range: 15 },
          { type: "CHR", tonic: "F", range: 15 },
          { type: "CHR", tonic: "F#", range: 15 },
          { type: "CHR", tonic: "G", range: 15 },
          { type: "DOM7", tonic: "A", range: 15 },
          { type: "DIM7", tonic: "G", range: 15 }
        ]
      },
      "7": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { type: "MAJ", tonic: "A", startOctave: "BOTH_UPPER_LOWER", range: 15 },
          { type: "MAJ", tonic: "Bb", startOctave: "BOTH_UPPER_LOWER", range: 15 },
          { type: "CHR", tonic: "ALL_KEYS", range: 15 },
          { type: "DOM7", tonic: "F#", range: 15 },
          { type: "DOM7", tonic: "G", range: 15 },
          { type: "DOM7", tonic: "Ab", range: 15 },
          { type: "DOM7", tonic: "A", range: 15 },
          { type: "DIM7", tonic: "C", range: 15 },
          { type: "DIM7", tonic: "Ab", range: 15 }
        ]
      },
      "8": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "A", range: 22 },
          { type: "MAJ", tonic: "Bb", range: 22 },
          { type: "MAJ", tonic: "B", range: 22 },
          { type: "MIN", tonic: "A", range: 22 },
          { type: "MIN", tonic: "Bb", range: 22 },
          { type: "MIN", tonic: "B", range: 22 },
          { type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { type: "CHR", tonic: "ALL_KEYS", range: 15 },
          { type: "WT", tonic: "B", range: 15 },
          { type: "WT", tonic: "C", range: 15 },
          { type: "DOM7", tonic: "ALL_KEYS", range: 15 },
          { type: "DIM7", tonic: "G", range: 15 },
          { type: "DIM7", tonic: "Ab", range: 15 },
          { type: "DIM7", tonic: "A", range: 15 }
        ]
      }
    },
    "baritone-euphonium": {
      "1": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Bb", range: 8 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "G", range: 8 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "C", range: 8 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "A", range: 8 }
        ]
      },
      "2": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Ab", range: 8 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "C", range: 8 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "G", range: 8 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "C", range: 8 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Bb", range: 8 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "D", range: 8 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "A", range: 8 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "D", range: 8 }
        ]
      },
      "3": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Db", range: 8 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "D", range: 8 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "Bb", range: 8 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "D", range: 8 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "G", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Eb", range: 8 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "E", range: 8 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "C", range: 8 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "E", range: 8 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "A", range: 12 },
          { subinst: "baritone-euphonium", type: "CHR", tonic: "Bb", range: 8 },
          { subinst: "baritone-euph-treble", type: "CHR", tonic: "C", range: 8 }
        ]
      },
      "4": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Eb", range: 8 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "Eb", range: 8 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "F#", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "G", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "A", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "F", range: 8 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "F", range: 8 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "A", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "B", range: 12 },
          { subinst: "baritone-euphonium", type: "CHR", tonic: "Ab", range: 12 }
        ]
      },
      "5": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "G#", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "B", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "F", range: 15 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "F#", range: 15 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "F", range: 15 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "G", range: 15 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Ab", range: 15 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "G", range: 15 },
          { subinst: "baritone-euphonium", type: "CHR", tonic: "Bb", range: 12 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "F", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "G", range: 15 }
        ]
      },
      "6": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "E", range: 15 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "G", range: 15 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Ab", range: 15 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "F#", range: 15 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "G", range: 15 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "G#", range: 15 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "C", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "F#", range: 15 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "A", range: 15 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Bb", range: 15 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "G#", range: 15 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "A", range: 15 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "Bb", range: 15 },
          { subinst: "baritone-euphonium", type: "CHR", tonic: "E", range: 15 },
          { subinst: "baritone-euphonium", type: "CHR", tonic: "F", range: 15 },
          { subinst: "baritone-euphonium", type: "CHR", tonic: "F#", range: 15 },
          { subinst: "baritone-euphonium", type: "CHR", tonic: "G", range: 15 },
          { subinst: "baritone-euph-treble", type: "CHR", tonic: "F#", range: 15 },
          { subinst: "baritone-euph-treble", type: "CHR", tonic: "G", range: 15 },
          { subinst: "baritone-euph-treble", type: "CHR", tonic: "Ab", range: 15 },
          { subinst: "baritone-euph-treble", type: "CHR", tonic: "A", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "baritone-euphonium", type: "DIM7", tonic: "F", range: 15 },
          { subinst: "baritone-euph-treble", type: "DIM7", tonic: "G", range: 15 }
        ]
      },
      "7": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "B", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "C", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "D", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "C", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "D", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "E", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "F", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "baritone-euphonium", type: "CHR", tonic: "E-A", range: 15 },
          { subinst: "baritone-euph-treble", type: "CHR", tonic: "F#-B", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "F", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "baritone-euphonium", type: "DIM7", tonic: "F#", range: 15 },
          { subinst: "baritone-euphonium", type: "DIM7", tonic: "G", range: 15 },
          { subinst: "baritone-euph-treble", type: "DIM7", tonic: "Ab", range: 15 },
          { subinst: "baritone-euph-treble", type: "DIM7", tonic: "A", range: 15 }
        ]
      },
      "8": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "B", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "C", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "D", range: 12 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "baritone-euphonium", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "baritone-euphonium", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "D", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "E", range: 12 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "F", range: 12 },
          { subinst: "baritone-euph-treble", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "baritone-euph-treble", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "baritone-euphonium", type: "CHR", tonic: "E-Bb", range: 15 },
          { subinst: "baritone-euph-treble", type: "CHR", tonic: "F#-C", range: 15 },
          { subinst: "baritone-euphonium", type: "WT", tonic: "A", range: 15 },
          { subinst: "baritone-euphonium", type: "WT", tonic: "Bb", range: 15 },
          { subinst: "baritone-euph-treble", type: "WT", tonic: "B", range: 15 },
          { subinst: "baritone-euph-treble", type: "WT", tonic: "C", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "E", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "F", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "baritone-euphonium", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "B", range: 15 },
          { subinst: "baritone-euph-treble", type: "DOM7", tonic: "C", range: 15 },
          { subinst: "baritone-euphonium", type: "DIM7", tonic: "F#", range: 15 },
          { subinst: "baritone-euphonium", type: "DIM7", tonic: "G", range: 15 },
          { subinst: "baritone-euphonium", type: "DIM7", tonic: "Ab", range: 15 },
          { subinst: "baritone-euph-treble", type: "DIM7", tonic: "Ab", range: 15 },
          { subinst: "baritone-euph-treble", type: "DIM7", tonic: "A", range: 15 },
          { subinst: "baritone-euph-treble", type: "DIM7", tonic: "Bb", range: 15 }
        ]
      }
    },
    "eb-horn": {
      "1": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "C", range: 8 },
          { type: "MIN", tonic: "A", range: 8 }
        ]
      },
      "2": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "Bb", range: 8 },
          { type: "MAJ", tonic: "D", range: 8 },
          { type: "MIN", tonic: "A", range: 8 },
          { type: "MIN", tonic: "D", range: 8 }
        ]
      },
      "3": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "Eb", range: 8 },
          { type: "MAJ", tonic: "E", range: 8 },
          { type: "MIN", tonic: "C", range: 8 },
          { type: "MIN", tonic: "E", range: 8 },
          { type: "MAJ", tonic: "A", range: 12 },
          { type: "CHR", tonic: "C", range: 8 }
        ]
      },
      "4": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "F", range: 8 },
          { type: "MIN", tonic: "F", range: 8 },
          { type: "MAJ", tonic: "Ab", range: 12 },
          { type: "MAJ", tonic: "Bb", range: 12 },
          { type: "MIN", tonic: "A", range: 12 },
          { type: "MIN", tonic: "B", range: 12 },
          { type: "CHR", tonic: "Bb", range: 12 }
        ]
      },
      "5": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { type: "MAJ", tonic: "Bb", range: 12 },
          { type: "MAJ", tonic: "Db", range: 12 },
          { type: "MIN", tonic: "Bb", range: 12 },
          { type: "MIN", tonic: "C#", range: 12 },
          { type: "MAJ", tonic: "G", range: 15 },
          { type: "MAJ", tonic: "Ab", range: 15 },
          { type: "MIN", tonic: "G", range: 15 },
          { type: "CHR", tonic: "C", range: 12 },
          { type: "DOM7", tonic: "G", range: 15 }
        ]
      },
      "6": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "D", range: 12 },
          { type: "MIN", tonic: "C", range: 12 },
          { type: "MAJ", tonic: "F#", range: 15 },
          { type: "MAJ", tonic: "A", range: 15 },
          { type: "MAJ", tonic: "Bb", range: 15 },
          { type: "MIN", tonic: "G#", range: 15 },
          { type: "MIN", tonic: "A", range: 15 },
          { type: "MIN", tonic: "Bb", range: 15 },
          { type: "CHR", tonic: "F#", range: 15 },
          { type: "CHR", tonic: "G", range: 15 },
          { type: "CHR", tonic: "Ab", range: 15 },
          { type: "CHR", tonic: "A", range: 15 },
          { type: "DOM7", tonic: "A", range: 15 },
          { type: "DIM7", tonic: "G", range: 15 }
        ]
      },
      "7": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "C", range: 12 },
          { type: "MAJ", tonic: "Db", range: 12 },
          { type: "MAJ", tonic: "D", range: 12 },
          { type: "MAJ", tonic: "Eb", range: 12 },
          { type: "MAJ", tonic: "E", range: 12 },
          { type: "MAJ", tonic: "F", range: 12 },
          { type: "MIN", tonic: "C", range: 12 },
          { type: "MIN", tonic: "C#", range: 12 },
          { type: "MIN", tonic: "D", range: 12 },
          { type: "MIN", tonic: "Eb", range: 12 },
          { type: "MIN", tonic: "E", range: 12 },
          { type: "MIN", tonic: "F", range: 12 },
          { type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { type: "CHR", tonic: "F#-B", range: 15 },
          { type: "DOM7", tonic: "G", range: 15 },
          { type: "DOM7", tonic: "Ab", range: 15 },
          { type: "DOM7", tonic: "Bb", range: 15 },
          { type: "DIM7", tonic: "Ab", range: 15 },
          { type: "DIM7", tonic: "A", range: 15 }
        ]
      },
      "8": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { type: "MAJ", tonic: "Db", range: 12 },
          { type: "MAJ", tonic: "D", range: 12 },
          { type: "MAJ", tonic: "Eb", range: 12 },
          { type: "MAJ", tonic: "E", range: 12 },
          { type: "MAJ", tonic: "F", range: 12 },
          { type: "MIN", tonic: "C#", range: 12 },
          { type: "MIN", tonic: "D", range: 12 },
          { type: "MIN", tonic: "Eb", range: 12 },
          { type: "MIN", tonic: "E", range: 12 },
          { type: "MIN", tonic: "F", range: 12 },
          { type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { type: "CHR", tonic: "F#-C", range: 15 },
          { type: "WT", tonic: "B", range: 15 },
          { type: "WT", tonic: "C", range: 15 },
          { type: "DOM7", tonic: "F#", range: 15 },
          { type: "DOM7", tonic: "G", range: 15 },
          { type: "DOM7", tonic: "Ab", range: 15 },
          { type: "DOM7", tonic: "A", range: 15 },
          { type: "DOM7", tonic: "Bb", range: 15 },
          { type: "DOM7", tonic: "B", range: 15 },
          { type: "DOM7", tonic: "C", range: 15 },
          { type: "DIM7", tonic: "Ab", range: 15 },
          { type: "DIM7", tonic: "A", range: 15 },
          { type: "DIM7", tonic: "Bb", range: 15 }
        ]
      }
    },
    "tuba": {
      "1": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "eb-tuba", type: "MAJ", tonic: "Eb", range: 8 },
          { subinst: "eb-tuba", type: "MIN", tonic: "C", range: 8 },
          { subinst: "f-tuba", type: "MAJ", tonic: "F", range: 8 },
          { subinst: "f-tuba", type: "MIN", tonic: "D", range: 8 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Bb", range: 8 },
          { subinst: "bb-tuba", type: "MIN", tonic: "G", range: 8 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "C", range: 8 },
          { subinst: "tuba-treble", type: "MIN", tonic: "A", range: 8 }
        ]
      },
      "2": {
        minorOptions: { subtypes: ["NAT", "HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "eb-tuba", type: "MAJ", tonic: "Db", range: 8 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "F", range: 8 },
          { subinst: "eb-tuba", type: "MIN", tonic: "C", range: 8 },
          { subinst: "eb-tuba", type: "MIN", tonic: "F", range: 8 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Eb", range: 8 },
          { subinst: "f-tuba", type: "MAJ", tonic: "G", range: 8 },
          { subinst: "f-tuba", type: "MIN", tonic: "D", range: 8 },
          { subinst: "f-tuba", type: "MIN", tonic: "G", range: 8 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Ab", range: 8 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "C", range: 8 },
          { subinst: "bb-tuba", type: "MIN", tonic: "G", range: 8 },
          { subinst: "bb-tuba", type: "MIN", tonic: "C", range: 8 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Bb", range: 8 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "D", range: 8 },
          { subinst: "tuba-treble", type: "MIN", tonic: "A", range: 8 },
          { subinst: "tuba-treble", type: "MIN", tonic: "D", range: 8 }
        ]
      },
      "3": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "eb-tuba", type: "MAJ", tonic: "F#", range: 8 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "G", range: 8 },
          { subinst: "eb-tuba", type: "MIN", tonic: "Eb", range: 8 },
          { subinst: "eb-tuba", type: "MIN", tonic: "G", range: 8 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Ab", range: 8 },
          { subinst: "f-tuba", type: "MAJ", tonic: "A", range: 8 },
          { subinst: "f-tuba", type: "MIN", tonic: "F", range: 8 },
          { subinst: "f-tuba", type: "MIN", tonic: "A", range: 8 },
          { subinst: "f-tuba", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Db", range: 8 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "D", range: 8 },
          { subinst: "bb-tuba", type: "MIN", tonic: "Bb", range: 8 },
          { subinst: "bb-tuba", type: "MIN", tonic: "D", range: 8 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "G", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Eb", range: 8 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "E", range: 8 },
          { subinst: "tuba-treble", type: "MIN", tonic: "C", range: 8 },
          { subinst: "tuba-treble", type: "MIN", tonic: "E", range: 8 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "A", range: 12 },
          { subinst: "eb-tuba", type: "CHR", tonic: "Eb", range: 8 },
          { subinst: "f-tuba", type: "CHR", tonic: "F", range: 8 },
          { subinst: "bb-tuba", type: "CHR", tonic: "Bb", range: 8 },
          { subinst: "tuba-treble", type: "CHR", tonic: "C", range: 8 }
        ]
      },
      "4": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "eb-tuba", type: "MAJ", tonic: "Ab", range: 8 },
          { subinst: "eb-tuba", type: "MIN", tonic: "G#", range: 8 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "C", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "D", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Bb", range: 8 },
          { subinst: "f-tuba", type: "MIN", tonic: "Bb", range: 8 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "D", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "E", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Eb", range: 8 },
          { subinst: "bb-tuba", type: "MIN", tonic: "Eb", range: 8 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "F#", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "G", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "A", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "F", range: 8 },
          { subinst: "tuba-treble", type: "MIN", tonic: "F", range: 8 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "A", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "B", range: 12 },
          { subinst: "eb-tuba", type: "CHR", tonic: "Db", range: 12 }
        ]
      },
      "5": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ANY" },
        scales: [
          { subinst: "eb-tuba", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "E", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "Bb", range: 15 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "B", range: 15 },
          { subinst: "eb-tuba", type: "MIN", tonic: "Bb", range: 15 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "F#", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "F#", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "C", range: 15 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Db", range: 15 },
          { subinst: "f-tuba", type: "MIN", tonic: "C", range: 15 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "G#", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "B", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "F", range: 15 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "F#", range: 15 },
          { subinst: "bb-tuba", type: "MIN", tonic: "F", range: 15 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "G", range: 15 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Ab", range: 15 },
          { subinst: "tuba-treble", type: "MIN", tonic: "G", range: 15 },
          { subinst: "eb-tuba", type: "CHR", tonic: "Eb", range: 12 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "C", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "F", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "G", range: 15 }
        ]
      },
      "6": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "eb-tuba", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "A", range: 15 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "C", range: 15 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "Db", range: 15 },
          { subinst: "eb-tuba", type: "MIN", tonic: "B", range: 15 },
          { subinst: "eb-tuba", type: "MIN", tonic: "C", range: 15 },
          { subinst: "eb-tuba", type: "MIN", tonic: "C#", range: 15 },
          { subinst: "f-tuba", type: "MAJ", tonic: "G", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "F", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "B", range: 15 },
          { subinst: "f-tuba", type: "MAJ", tonic: "D", range: 15 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Eb", range: 15 },
          { subinst: "f-tuba", type: "MIN", tonic: "C#", range: 15 },
          { subinst: "f-tuba", type: "MIN", tonic: "D", range: 15 },
          { subinst: "f-tuba", type: "MIN", tonic: "Eb", range: 15 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "E", range: 15 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "G", range: 15 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Ab", range: 15 },
          { subinst: "bb-tuba", type: "MIN", tonic: "F#", range: 15 },
          { subinst: "bb-tuba", type: "MIN", tonic: "G", range: 15 },
          { subinst: "bb-tuba", type: "MIN", tonic: "G#", range: 15 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "C", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "F#", range: 15 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "A", range: 15 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Bb", range: 15 },
          { subinst: "tuba-treble", type: "MIN", tonic: "G#", range: 15 },
          { subinst: "tuba-treble", type: "MIN", tonic: "A", range: 15 },
          { subinst: "tuba-treble", type: "MIN", tonic: "Bb", range: 15 },
          { subinst: "eb-tuba", type: "CHR", tonic: "A", range: 15 },
          { subinst: "eb-tuba", type: "CHR", tonic: "Bb", range: 15 },
          { subinst: "eb-tuba", type: "CHR", tonic: "B", range: 15 },
          { subinst: "eb-tuba", type: "CHR", tonic: "C", range: 15 },
          { subinst: "f-tuba", type: "CHR", tonic: "B", range: 15 },
          { subinst: "f-tuba", type: "CHR", tonic: "C", range: 15 },
          { subinst: "f-tuba", type: "CHR", tonic: "Db", range: 15 },
          { subinst: "f-tuba", type: "CHR", tonic: "D", range: 15 },
          { subinst: "bb-tuba", type: "CHR", tonic: "E", range: 15 },
          { subinst: "bb-tuba", type: "CHR", tonic: "F", range: 15 },
          { subinst: "bb-tuba", type: "CHR", tonic: "F#", range: 15 },
          { subinst: "bb-tuba", type: "CHR", tonic: "G", range: 15 },
          { subinst: "tuba-treble", type: "CHR", tonic: "F#", range: 15 },
          { subinst: "tuba-treble", type: "CHR", tonic: "G", range: 15 },
          { subinst: "tuba-treble", type: "CHR", tonic: "Ab", range: 15 },
          { subinst: "tuba-treble", type: "CHR", tonic: "A", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "C", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "D", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "eb-tuba", type: "DIM7", tonic: "Bb", range: 15 },
          { subinst: "f-tuba", type: "DIM7", tonic: "C", range: 15 },
          { subinst: "bb-tuba", type: "DIM7", tonic: "F", range: 15 },
          { subinst: "tuba-treble", type: "DIM7", tonic: "G", range: 15 }
        ]
      },
      "7": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "eb-tuba", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "F#", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "G", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "E", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "F", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "F#", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "G", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "G#", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "eb-tuba", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "f-tuba", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "F#", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "G", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "A", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "F", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "F#", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "G", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "G#", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "A", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "f-tuba", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "B", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "C", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "D", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "bb-tuba", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "C", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "D", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "E", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "F", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "tuba-treble", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "eb-tuba", type: "CHR", tonic: "A-D", range: 15 },
          { subinst: "f-tuba", type: "CHR", tonic: "B-E", range: 15 },
          { subinst: "bb-tuba", type: "CHR", tonic: "E-A", range: 15 },
          { subinst: "tuba-treble", type: "CHR", tonic: "F#-B", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "B", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "C#", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "C", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "C#", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "Eb", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "F", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "eb-tuba", type: "DIM7", tonic: "B", range: 15 },
          { subinst: "eb-tuba", type: "DIM7", tonic: "C", range: 15 },
          { subinst: "f-tuba", type: "DIM7", tonic: "Db", range: 15 },
          { subinst: "f-tuba", type: "DIM7", tonic: "D", range: 15 },
          { subinst: "bb-tuba", type: "DIM7", tonic: "F#", range: 15 },
          { subinst: "bb-tuba", type: "DIM7", tonic: "G", range: 15 },
          { subinst: "tuba-treble", type: "DIM7", tonic: "Ab", range: 15 },
          { subinst: "tuba-treble", type: "DIM7", tonic: "A", range: 15 }
        ]
      },
      "8": {
        minorOptions: { subtypes: ["HAR", "MEL"], requirement: "ALL" },
        scales: [
          { subinst: "eb-tuba", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "F#", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "G", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "E", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "F", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "F#", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "G", range: 12 },
          { subinst: "eb-tuba", type: "MIN", tonic: "G#", range: 12 },
          { subinst: "eb-tuba", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "eb-tuba", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "f-tuba", type: "MAJ", tonic: "F#", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "G", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Ab", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "A", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "Bb", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "F#", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "G", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "G#", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "A", range: 12 },
          { subinst: "f-tuba", type: "MIN", tonic: "Bb", range: 12 },
          { subinst: "f-tuba", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "f-tuba", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "B", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "C", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "B", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "C", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "D", range: 12 },
          { subinst: "bb-tuba", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "bb-tuba", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "bb-tuba", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Db", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "D", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "Eb", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "E", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "F", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "C#", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "D", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "Eb", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "E", range: 12 },
          { subinst: "tuba-treble", type: "MIN", tonic: "F", range: 12 },
          { subinst: "tuba-treble", type: "MAJ", tonic: "ALL_KEYS", range: 15 },
          { subinst: "tuba-treble", type: "MIN", tonic: "ALL_KEYS", range: 15 },
          { subinst: "eb-tuba", type: "CHR", tonic: "A-Eb", range: 15 },
          { subinst: "f-tuba", type: "CHR", tonic: "B-F", range: 15 },
          { subinst: "bb-tuba", type: "CHR", tonic: "E-Bb", range: 15 },
          { subinst: "tuba-treble", type: "CHR", tonic: "F#-C", range: 15 },
          { subinst: "eb-tuba", type: "WT", tonic: "D", range: 15 },
          { subinst: "eb-tuba", type: "WT", tonic: "Eb", range: 15 },
          { subinst: "f-tuba", type: "WT", tonic: "E", range: 15 },
          { subinst: "f-tuba", type: "WT", tonic: "F", range: 15 },
          { subinst: "bb-tuba", type: "WT", tonic: "A", range: 15 },
          { subinst: "bb-tuba", type: "WT", tonic: "Bb", range: 15 },
          { subinst: "tuba-treble", type: "WT", tonic: "B", range: 15 },
          { subinst: "tuba-treble", type: "WT", tonic: "C", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "B", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "C", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "C#", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "D", range: 15 },
          { subinst: "eb-tuba", type: "DOM7", tonic: "Eb", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "B", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "C", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "C#", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "D", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "Eb", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "E", range: 15 },
          { subinst: "f-tuba", type: "DOM7", tonic: "F", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "E", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "F", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "bb-tuba", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "F#", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "G", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "Ab", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "A", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "Bb", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "B", range: 15 },
          { subinst: "tuba-treble", type: "DOM7", tonic: "C", range: 15 },
          { subinst: "eb-tuba", type: "DIM7", tonic: "B", range: 15 },
          { subinst: "eb-tuba", type: "DIM7", tonic: "C", range: 15 },
          { subinst: "eb-tuba", type: "DIM7", tonic: "Db", range: 15 },
          { subinst: "f-tuba", type: "DIM7", tonic: "Db", range: 15 },
          { subinst: "f-tuba", type: "DIM7", tonic: "D", range: 15 },
          { subinst: "f-tuba", type: "DIM7", tonic: "Eb", range: 15 },
          { subinst: "bb-tuba", type: "DIM7", tonic: "F#", range: 15 },
          { subinst: "bb-tuba", type: "DIM7", tonic: "G", range: 15 },
          { subinst: "bb-tuba", type: "DIM7", tonic: "Ab", range: 15 },
          { subinst: "tuba-treble", type: "DIM7", tonic: "Ab", range: 15 },
          { subinst: "tuba-treble", type: "DIM7", tonic: "A", range: 15 },
          { subinst: "tuba-treble", type: "DIM7", tonic: "Bb", range: 15 }
        ]
      }
    }
  }